import { IMAGE_OPTIMIZATION_CDN_URL } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

export const ONBOARDING_ASSETS_URL = `${IMAGE_OPTIMIZATION_CDN_URL}/onboarding/onboarding_icons`;

export const RESENT_OTP_TIME = 30000;

export const ONBOARDING_ASSETS_RELATIVE_PATH = "assets/images/onboarding";

export const LOGIN_GRANT_TYPES = {
  google: "google",
  emailNew: "emailNew",
  emailOld: "emailOld",
};
